import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';
import { ReportType } from '@games/entities';
import { IReportType } from '@games/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  constructor(private http: HttpClient) {}

  getReportTypes(courseId: number, gameId: number): Observable<ReportType[]> {
    return this.http
      .get<any>(`${environment.apiUrl}courses/${courseId}/games/${gameId}/reports/`)
      .pipe(
        map((reportTypes: IReportType[]) =>
          reportTypes.map((reportType: IReportType) => new ReportType(reportType))
        )
      );
  }

  getXLSReport(courseId: number, gameId: number): Observable<HttpResponse<Blob>> {
    return this.http.post<Blob>(
      `${environment.apiUrl}courses/${courseId}/games/${gameId}/xls_download/`,
      {},
      {
        observe: 'response',
        responseType: 'blob' as 'json',
      }
    );
  }

  /**
   * Generates any report from the list endpoint. Despite the `get_url` name the
   * response body is the report HTML fragment, not a URL.
   *
   * The extra parameter is driven by the report's scope: entity reports send
   * `entity_id`, market/grouping reports send `grouping_id`, economy-wide
   * reports send neither.
   */
  getReportHtml(
    courseId: number,
    gameId: number,
    reportId: number,
    period: number,
    scopeParams: { entityId?: number | string; groupingId?: number | string } = {}
  ): Observable<string> {
    const body: { period: number; entity_id?: number | string; grouping_id?: number | string } = {
      period,
    };

    if (scopeParams.entityId != null) {
      body.entity_id = scopeParams.entityId;
    }

    if (scopeParams.groupingId != null) {
      body.grouping_id = scopeParams.groupingId;
    }

    return this.http.post(
      `${environment.apiUrl}courses/${courseId}/games/${gameId}/reports/${reportId}/get_url/`,
      body,
      { responseType: 'text' }
    );
  }

  getDdayReportHtml(
    courseId: number,
    gameId: number,
    reportId: number,
    period: number,
    entityId: number
  ): Observable<string> {
    return this.getReportHtml(courseId, gameId, reportId, period, { entityId });
  }
}
